import Select2 from '../../../src/js/shared/select2';

'use strict';
const $ = jQuery.noConflict();
$(function() {
	const providerListing = {
		searchDebounceMs: 350,
		debounceTimer: null,
		currentCategory: '',
		currentPage: 1,
		resetting: false,
		requestInFlight: false,

		init: function() {
			this.cacheDOM();
			if (!this.$root.length) return;
			this.initSelects();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$root = $('.provider-listing');
			this.$search = $('.js-provider-listing-search');
			this.$state = $('.js-provider-listing-state');
			this.$insurance = $('.js-provider-listing-insurance');
			this.$tabs = $('.js-provider-listing-tab');
			this.$count = $('.js-provider-listing-count');
			this.$empty = $('.js-provider-listing-empty');
			this.$results = $('.js-provider-listing-results');
			this.$loadMoreWrap = $('.js-provider-listing-load-more-wrap');
			this.$loadMoreBtn = $('.js-provider-listing-load-more');
			this.ajaxAction = this.$root.data('ajax-action');
			this.currentCategory = this.$root.data('default-category') || '';
		},

		initSelects: function() {
			Select2.initializeSelect2('.js-provider-listing-state, .js-provider-listing-insurance', {
				theme: 'default select2--custom-theme select2--provider-listing',
				dropdownCssClass: 'select2--provider-listing-dropdown',
			});
		},

		bindEvents: function() {
			this.$tabs.on('click', this.onTabClick.bind(this));
			this.$search.on('input', this.onSearchInput.bind(this));
			this.$state.on('change', this.onFilterChange.bind(this));
			this.$insurance.on('change', this.onFilterChange.bind(this));
			this.$loadMoreBtn.on('click', this.onLoadMoreClick.bind(this));
		},

		onTabClick: function(event) {
			const $tab = $(event.currentTarget);
			if ($tab.hasClass('is-active')) return;

			this.$tabs.removeClass('is-active').attr('aria-selected', 'false');
			$tab.addClass('is-active').attr('aria-selected', 'true');
			this.currentCategory = $tab.data('category');

			// changing category resets search + state + insurance, per FWS
			this.resetting = true;
			this.$search.val('');
			this.$state.val('').trigger('change');
			this.$insurance.val('').trigger('change');
			this.resetting = false;

			this.fetchResults(true);
		},

		onSearchInput: function() {
			clearTimeout(this.debounceTimer);
			this.debounceTimer = setTimeout(() => this.fetchResults(true), this.searchDebounceMs);
		},

		onFilterChange: function() {
			if (this.resetting) return;
			this.fetchResults(true);
		},

		onLoadMoreClick: function() {
			this.fetchResults(false);
		},

		fetchResults: function(reset) {
			if (this.requestInFlight) return;

			const page = reset ? 1 : this.currentPage + 1;
			const data = {
				action: this.ajaxAction,
				category: this.currentCategory,
				state: this.$state.val() || '',
				insurance: this.$insurance.val() || '',
				search: this.$search.val() || '',
				page: page,
			};

			this.requestInFlight = true;
			this.toggleLoading(true);

			$.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: data,
				success: (response) => this.onSuccess(response, reset, page),
				error: this.onError,
				complete: () => {
					this.requestInFlight = false;
					this.toggleLoading(false);
				},
			});
		},

		onSuccess: function(response, reset, page) {
			if (!response.success || !response.data) return;
			const data = response.data;

			if (reset) {
				this.$results.html(data.html || '');
			} else if (data.html) {
				this.$results.append(data.html);
			}

			this.currentPage = data.page || page;
			this.$loadMoreWrap.prop('hidden', !data.hasMore);
			this.$empty.prop('hidden', data.total > 0);
			this.$results.prop('hidden', data.total === 0);
			this.updateCountLabel(data.total, data.stateLabel);
		},

		onError: function(jqXHR, textStatus, errorThrown) {
			console.error('AJAX error: ' + textStatus + ' - ' + errorThrown);
		},

		updateCountLabel: function(total, stateLabel) {
			const noun = total === 1 ? 'provider' : 'providers';
			const suffix = stateLabel === 'nationwide' ? 'nationwide' : `in ${stateLabel}`;
			this.$count.text(`Showing ${total} ${noun} ${suffix}`);
		},

		toggleLoading: function(state) {
			this.$loadMoreWrap.toggleClass('show-spinner', state);
			this.$root.toggleClass('is-loading', state);
		},
	};

	providerListing.init();
});
